/**
 * Styles for wf-skip-btn component (Shadow DOM)
 */

import { css } from 'lit';

export const wfSkipBtnStyles = css`
  :host {
    display: block;
    text-align: center;
  }

  :host([hidden]) {
    display: none;
  }

  .wf-skip-link {
    display: inline-block;
    padding: var(--wf-spacing-3, 12px) var(--wf-spacing-4, 16px);
    font-size: var(--wf-font-size-sm, 0.875rem);
    font-family: inherit;
    color: var(--wf-color-text-muted, #646464);
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 150ms ease;
    outline: none;
  }

  .wf-skip-link:hover {
    color: var(--wf-color-text, #0a0a0a);
  }

  .wf-skip-link:focus-visible {
    border-radius: var(--wf-radius-sm, 4px);
    box-shadow: 0 0 0 var(--wf-focus-ring-width, 3px) var(--wf-focus-ring-primary, rgba(128, 64, 240, 0.2));
  }
`;
